export default __webpack_public_path__ + "static/media/vetor-mamografia.47ff9956.svg";